import { createLocalConfig } from "./envs/local";
import { createProdConfig } from "./envs/prod";
import { createDevConfig } from "./envs/dev";

export const appConfig = getConfig();

function getConfig() {
  switch (process.env.REACT_APP_ENV) {
    case "production":
      return createProdConfig();
    case "development":
      return createDevConfig();
    case "local":
      return createLocalConfig();
    default:
      throw new Error(`Invalid APP_ENV "${process.env.REACT_APP_ENV}"`);
  }
}
